export enum DateShortFilter {
  Today,
  LastWeek,
  ThisWeek,
  NextWeek,
  LastMonth,
  ThisMonth,
  NextMonth,
}
